<!-- <p>address-list works!</p> -->
<div class="address_cont {{addressData.primaryBillingAddress || addressData.primaryShippingAddress?'default_address_cont':''}}">
	<button class="edit" (click)="editAddressMeth()">
		<span class="material-symbols-outlined">
			edit
		</span>
	</button>
	<button class="delete" (click)="deleteAddressMeth()" *ngIf="!addressData.primaryBillingAddress && !addressData.primaryShippingAddress">
		<span class="material-symbols-outlined">
			delete
		</span>
	</button>
	<h4>
		{{addressData.name}}
		<span *ngIf="addressData.primaryBillingAddress || addressData.primaryShippingAddress">
			( Default )
		</span>
	</h4>
	<p class="ad_line1">
		<span *ngIf="addressData.addressLineOne">{{addressData.addressLineOne}}</span>
		<span *ngIf="addressData.addressLineTwo">, {{addressData.addressLineTwo}}</span>
		<span *ngIf="addressData.city">, {{addressData.city}}</span>
		<span *ngIf="addressData.state">, {{addressData.state}}</span>
		<span *ngIf="addressData.postalCode">, {{addressData.postalCode}}</span>
		<span *ngIf="addressData.country">, {{addressData.country}}</span>
	</p>
	<p class="ad_line2 contact_details_cont">
		<span class="material-symbols-outlined icon call_icon">
			call
		</span>
		<span>
			<span *ngIf="addressData.primaryPhone">{{addressData.primaryPhone}}</span>
			<span *ngIf="addressData.secondaryPhone">, {{addressData.secondaryPhone}}</span>
		</span>
	</p>
	<p class="ad_line2 contact_details_cont">
		<span class="material-symbols-outlined icon email_icon">
			mail
		</span>
		<span>
			<span *ngIf="addressData.contactEmail">{{addressData.contactEmail}}</span>
		</span>
	</p>
	<!-- <p class="ad_line1" *ngIf="addressData.addressLineOne">
		{{addressData.addressLineOne}}
	</p>
	<p class="ad_line2" *ngIf="addressData.addressLineTwo">{{addressData.addressLineTwo}}</p> -->
	<span class="setAsDefault" (click)="setDefaultAddress()"
		*ngIf="!addressData.primaryBillingAddress && !addressData.primaryShippingAddress">
		Set Default Address
	</span>

	<span class="select_address" *ngIf="isCheckoutPage" (click)="selectThisAddress(addressData)">
		Select
	</span>
</div>
